import React from "react";
import Content from "./Content";
import { Card } from "./Card";

const TeamCard = () => {
  return (
    <center>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-[1rem] sm:gap-[2rem] object-cover ">
    {Content.map((content) => (
      <Card
        key={content.id}
        image={content.image}
        name={content.name}
        post={content.post}
        socialmedia={content.socialmedia}
      />
    ))}
  </div>
  </center>
  
  );
};

export default TeamCard;
